import {Component, OnInit} from '@angular/core';
import {OrganizationService} from '../../../service/organization.service';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../../service/user.service';
import {ApiUserService} from '../../../service/api-user.service';
import {PopupsComponent} from '../../../modal-edit/popups/popups.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { StoreFilterCount } from '../../../shared/interfaces/storeFilterCount';

@Component({
  selector: 'app-organization-users',
  templateUrl: './organization-users.component.html',
  styleUrls: ['./organization-users.component.scss']
})
export class OrganizationUsersComponent implements OnInit, StoreFilterCount {
  orgUsers = [];
  searchTerm: string;
  statusFilter;
  retrievingData = true;
  order;
  direction = null;

  page: number = 1;
  pageSize: number = 10;
  totalUsers: number = this.orgUsers.length;

  constructor(private orgService: OrganizationService,
              private userService: UserService,
              private apiUserService: ApiUserService,
              private modalService: NgbModal,
              private route: ActivatedRoute) {
  }

  ngOnInit() {

    this.statusFilter = null;

    // live observables
    this.userService.newSearchSubject
      .subscribe((result) => {
        this.page = 1;
        this.searchTerm = result;
      });

    this.apiUserService.newApiUserSubject.subscribe(user => {
      if (user && user !== null) {
        this.orgUsers.push(user);
      }
    });

    this.orgService.getOrganizations(this.route.snapshot.params['id'], null)
      .subscribe(users => {
        this.orgUsers = users;
        this.page = 1;
        this.totalUsers = this.orgUsers.length;
        this.retrievingData = false;
      });

    this.userService.newSearchSubject
      .subscribe((result) => {
        this.searchTerm = result;
      });


    this.userService.newStatusSubject
      .subscribe((result) => {
        this.statusFilter = result;
      });
  }

  updateItemCount(newCount: number) {
    this.totalUsers = newCount;
  }

  onSetOrder(order) {
    this.page = 1;
    if (this.order === order) {
      if (this.direction === null) {
        this.direction = 'reverse';
      } else {
        this.direction = null;
      }
    }
    this.order = order;
  }

  onStatusToggler(status) {
    switch (status) {
      case 'all':
        this.statusFilter = null;
        break;
      case 'active':
        this.statusFilter = true;
        break;
      case 'disabled':
        this.statusFilter = false;
        break;
      default:
        break;
    }
  }

  disableUser(user) {
    let text = '';
    if (!user.status) {
      text = 'enable';
    } else {
      text = 'disable';
    }
    if (confirm('Are you sure you want to ' + text + ' ' + user.name + '?')) {
      this.apiUserService.ableUser(user, text)
        .subscribe((result) => {
          user.status = !user.status;
        });
    }
  }

  deleteUser(user) {
    let index;
    if (confirm('Are you sure you want to delete ' + user.name + '?')) {
      index = this.orgUsers.indexOf(user);
      this.orgUsers.splice(index, 1);
      this.apiUserService.deleteApiUser(user)
        .subscribe((result) => {
        });
    }
  }

  regenerateKey(user) {
    this.apiUserService.regenerateKey(user)
      .subscribe((result) => {
        let modalRef;
        this.userService.setPopupObject(result);
        modalRef = this.modalService.open(PopupsComponent, { backdrop: 'static' });
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/main/organizations/organization-users/organization-users.component.ts